import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import ContentLayout from '€layouts/ContentLayout';

import { Hidden } from '€components/Hidden';
import CenterSmUp from '€components/CenterSmUp';
import BrandLogoLGSVG from '€components/svgs/loan-logo-lg.svg';
import BrandLogoSMSVG from '€components/svgs/loan-logo-sml.svg';
import HandshakeLogoSVG from '€components/svgs/handshake-2.svg';
import PageLayout, { PageLayoutProps } from '€layouts/PageLayout';

type Props = {
    flashMessage?: React.ReactNode;
    title?: string;
    subtitle?: string;
    action?: React.ReactNode;
} & PageLayoutProps;

const PreAuthContentLayout = ({ children }) => {
    const theme = useTheme();

    return (
        <ContentLayout>
            <Box
                flex={1}
                display="flex"
                alignItems="center"
                maxWidth={['100vw', '57.75rem']}
                flexDirection="column"
                width="100vw"
            >
                {children}
            </Box>
        </ContentLayout>
    );
};

const PreAuthLayout = ({
    title,
    subtitle,
    children,
    flashMessage,
    ...layoutProps
}: React.PropsWithChildren<Props>) => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('sm'));
    return (
        <PageLayout contentComponent={PreAuthContentLayout} {...layoutProps}>
            <Hidden smUp>
                <Box py="1.875rem" display="flex" justifyContent="flex-start">
                    <BrandLogoSMSVG />
                </Box>
            </Hidden>
            <Hidden xsDown>
                <Box
                    py="2.75rem"
                    display="flex"
                    justifyContent="flex-start"
                    width="100vw"
                    pl="5rem"
                >
                    <BrandLogoLGSVG />
                </Box>
            </Hidden>
            <Box
                flex={1}
                px={3}
                display="flex"
                maxWidth={['100vw', '38rem']}
                flexDirection="column"
                width="100vw"
                mb="2.813rem"
                alignItems="center"
            >
                <Box
                    pt={{ xs: 0, sm: 4 }}
                    pb={4}
                    px={{ xs: 0, sm: 13 }}
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    border={`${matches ? '1px solid #D6DDE6' : 'none'}`}
                    borderRadius="8px"
                    maxWidth="509px"
                >
                    <Box display="flex" justifyContent="center">
                        <HandshakeLogoSVG />
                    </Box>
                    <Box
                        mt={0.5}
                        mb="1.875rem"
                        textAlign="center"
                        display="flex"
                        flexDirection="column"
                    >
                        {title && (
                            <Box pb={2}>
                                <Typography component="h1" variant="h1">
                                    {title}
                                </Typography>
                            </Box>
                        )}
                        {subtitle && <Typography variant="body1">{subtitle}</Typography>}
                        {flashMessage && (
                            <CenterSmUp>
                                <Box mt={3} mb={2}>
                                    {flashMessage}
                                </Box>
                            </CenterSmUp>
                        )}
                    </Box>
                    {children}
                </Box>
            </Box>
        </PageLayout>
    );
};

export default PreAuthLayout;
